// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Lens_At = require("../Data.Lens.At/index.js");
var Data_Lens_Fold = require("../Data.Lens.Fold/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Internal_Market = require("../Data.Lens.Internal.Market/index.js");
var Data_Lens_Internal_Wander = require("../Data.Lens.Internal.Wander/index.js");
var Data_Lens_Iso_Newtype = require("../Data.Lens.Iso.Newtype/index.js");
var Data_Lens_Prism = require("../Data.Lens.Prism/index.js");
var Data_Lens_Prism_Maybe = require("../Data.Lens.Prism.Maybe/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Maybe_First = require("../Data.Maybe.First/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Profunctor = require("../Data.Profunctor/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query = require("../Halogen.Query/index.js");
var Halogen_Query_EventSource = require("../Halogen.Query.EventSource/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Capability_Navigate = require("../Lunarbox.Capability.Navigate/index.js");
var Lunarbox_Component_Editor_Add = require("../Lunarbox.Component.Editor.Add/index.js");
var Lunarbox_Component_Editor_NodePreview = require("../Lunarbox.Component.Editor.NodePreview/index.js");
var Lunarbox_Component_Editor_NodeUi = require("../Lunarbox.Component.Editor.NodeUi/index.js");
var Lunarbox_Component_Editor_Problems = require("../Lunarbox.Component.Editor.Problems/index.js");
var Lunarbox_Component_Editor_Scene = require("../Lunarbox.Component.Editor.Scene/index.js");
var Lunarbox_Component_Editor_Tree = require("../Lunarbox.Component.Editor.Tree/index.js");
var Lunarbox_Component_Icon = require("../Lunarbox.Component.Icon/index.js");
var Lunarbox_Component_Modal = require("../Lunarbox.Component.Modal/index.js");
var Lunarbox_Component_Switch = require("../Lunarbox.Component.Switch/index.js");
var Lunarbox_Component_Tooltip = require("../Lunarbox.Component.Tooltip/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Data_Class_GraphRep = require("../Lunarbox.Data.Class.GraphRep/index.js");
var Lunarbox_Data_Dataflow_Expression_Lint = require("../Lunarbox.Data.Dataflow.Expression.Lint/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var Lunarbox_Data_Dataflow_Runtime_TermEnvironment = require("../Lunarbox.Data.Dataflow.Runtime.TermEnvironment/index.js");
var Lunarbox_Data_Dataflow_Runtime_ValueMap = require("../Lunarbox.Data.Dataflow.Runtime.ValueMap/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Dataflow_TypeError = require("../Lunarbox.Data.Dataflow.TypeError/index.js");
var Lunarbox_Data_Editor_DataflowFunction = require("../Lunarbox.Data.Editor.DataflowFunction/index.js");
var Lunarbox_Data_Editor_EditNode = require("../Lunarbox.Data.Editor.EditNode/index.js");
var Lunarbox_Data_Editor_FunctionData = require("../Lunarbox.Data.Editor.FunctionData/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Location = require("../Lunarbox.Data.Editor.Location/index.js");
var Lunarbox_Data_Editor_Node = require("../Lunarbox.Data.Editor.Node/index.js");
var Lunarbox_Data_Editor_Node_NodeDescriptor = require("../Lunarbox.Data.Editor.Node.NodeDescriptor/index.js");
var Lunarbox_Data_Editor_Node_PinLocation = require("../Lunarbox.Data.Editor.Node.PinLocation/index.js");
var Lunarbox_Data_Editor_Project = require("../Lunarbox.Data.Editor.Project/index.js");
var Lunarbox_Data_Editor_Save = require("../Lunarbox.Data.Editor.Save/index.js");
var Lunarbox_Data_Editor_State = require("../Lunarbox.Data.Editor.State/index.js");
var Lunarbox_Data_Graph = require("../Lunarbox.Data.Graph/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Lunarbox_Data_Set = require("../Lunarbox.Data.Set/index.js");
var Lunarbox_Data_Tab = require("../Lunarbox.Data.Tab/index.js");
var Lunarbox_Foreign_Render = require("../Lunarbox.Foreign.Render/index.js");
var Record = require("../Record/index.js");
var Web_Event_Event = require("../Web.Event.Event/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_HTMLDocument = require("../Web.HTML.HTMLDocument/index.js");
var Web_HTML_HTMLElement = require("../Web.HTML.HTMLElement/index.js");
var Web_HTML_HTMLInputElement = require("../Web.HTML.HTMLInputElement/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var Web_UIEvent_KeyboardEvent = require("../Web.UIEvent.KeyboardEvent/index.js");
var Web_UIEvent_KeyboardEvent_EventTypes = require("../Web.UIEvent.KeyboardEvent.EventTypes/index.js");
var GetState = (function () {
    function GetState(value0) {
        this.value0 = value0;
    };
    GetState.create = function (value0) {
        return new GetState(value0);
    };
    return GetState;
})();
var NoProblems = (function () {
    function NoProblems() {

    };
    NoProblems.value = new NoProblems();
    return NoProblems;
})();
var Warnings = (function () {
    function Warnings() {

    };
    Warnings.value = new Warnings();
    return Warnings;
})();
var Errors = (function () {
    function Errors() {

    };
    Errors.value = new Errors();
    return Errors;
})();
var AutofixConnection = (function () {
    function AutofixConnection() {

    };
    AutofixConnection.value = new AutofixConnection();
    return AutofixConnection;
})();
var CancelConnecting = (function () {
    function CancelConnecting() {

    };
    CancelConnecting.value = new CancelConnecting();
    return CancelConnecting;
})();
var ProceedConnecting = (function () {
    function ProceedConnecting() {

    };
    ProceedConnecting.value = new ProceedConnecting();
    return ProceedConnecting;
})();
var Save = (function () {
    function Save(value0) {
        this.value0 = value0;
    };
    Save.create = function (value0) {
        return new Save(value0);
    };
    return Save;
})();
var StateEmit = (function () {
    function StateEmit(value0) {
        this.value0 = value0;
    };
    StateEmit.create = function (value0) {
        return new StateEmit(value0);
    };
    return StateEmit;
})();
var NEDeleteNode = (function () {
    function NEDeleteNode() {

    };
    NEDeleteNode.value = new NEDeleteNode();
    return NEDeleteNode;
})();
var NECloseModal = (function () {
    function NECloseModal() {

    };
    NECloseModal.value = new NECloseModal();
    return NECloseModal;
})();
var Init = (function () {
    function Init() {

    };
    Init.value = new Init();
    return Init;
})();
var HandleKey = (function () {
    function HandleKey(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    HandleKey.create = function (value0) {
        return function (value1) {
            return new HandleKey(value0, value1);
        };
    };
    return HandleKey;
})();
var ChangeTab = (function () {
    function ChangeTab(value0) {
        this.value0 = value0;
    };
    ChangeTab.create = function (value0) {
        return new ChangeTab(value0);
    };
    return ChangeTab;
})();
var CreateFunction = (function () {
    function CreateFunction(value0) {
        this.value0 = value0;
    };
    CreateFunction.create = function (value0) {
        return new CreateFunction(value0);
    };
    return CreateFunction;
})();
var SelectFunction = (function () {
    function SelectFunction(value0) {
        this.value0 = value0;
    };
    SelectFunction.create = function (value0) {
        return new SelectFunction(value0);
    };
    return SelectFunction;
})();
var CreateNode = (function () {
    function CreateNode(value0) {
        this.value0 = value0;
    };
    CreateNode.create = function (value0) {
        return new CreateNode(value0);
    };
    return CreateNode;
})();
var StartFunctionCreation = (function () {
    function StartFunctionCreation() {

    };
    StartFunctionCreation.value = new StartFunctionCreation();
    return StartFunctionCreation;
})();
var RemoveConnection = (function () {
    function RemoveConnection(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    RemoveConnection.create = function (value0) {
        return function (value1) {
            return new RemoveConnection(value0, value1);
        };
    };
    return RemoveConnection;
})();
var TogglePanel = (function () {
    function TogglePanel() {

    };
    TogglePanel.value = new TogglePanel();
    return TogglePanel;
})();
var ChangeInputCount = (function () {
    function ChangeInputCount(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ChangeInputCount.create = function (value0) {
        return function (value1) {
            return new ChangeInputCount(value0, value1);
        };
    };
    return ChangeInputCount;
})();
var SetName = (function () {
    function SetName(value0) {
        this.value0 = value0;
    };
    SetName.create = function (value0) {
        return new SetName(value0);
    };
    return SetName;
})();
var SetExample = (function () {
    function SetExample(value0) {
        this.value0 = value0;
    };
    SetExample.create = function (value0) {
        return new SetExample(value0);
    };
    return SetExample;
})();
var SearchNodes = (function () {
    function SearchNodes(value0) {
        this.value0 = value0;
    };
    SearchNodes.create = function (value0) {
        return new SearchNodes(value0);
    };
    return SearchNodes;
})();
var SetVisibility = (function () {
    function SetVisibility(value0) {
        this.value0 = value0;
    };
    SetVisibility.create = function (value0) {
        return new SetVisibility(value0);
    };
    return SetVisibility;
})();
var HandleAddPanelKeyPress = (function () {
    function HandleAddPanelKeyPress(value0) {
        this.value0 = value0;
    };
    HandleAddPanelKeyPress.create = function (value0) {
        return new HandleAddPanelKeyPress(value0);
    };
    return HandleAddPanelKeyPress;
})();
var DeleteFunction = (function () {
    function DeleteFunction(value0) {
        this.value0 = value0;
    };
    DeleteFunction.create = function (value0) {
        return new DeleteFunction(value0);
    };
    return DeleteFunction;
})();
var Navigate = (function () {
    function Navigate(value0) {
        this.value0 = value0;
    };
    Navigate.create = function (value0) {
        return new Navigate(value0);
    };
    return Navigate;
})();
var LoadScene = (function () {
    function LoadScene() {

    };
    LoadScene.value = new LoadScene();
    return LoadScene;
})();
var Rerender = (function () {
    function Rerender() {

    };
    Rerender.value = new Rerender();
    return Rerender;
})();
var DeleteNode = (function () {
    function DeleteNode(value0) {
        this.value0 = value0;
    };
    DeleteNode.create = function (value0) {
        return new DeleteNode(value0);
    };
    return DeleteNode;
})();
var UpdatePreview = (function () {
    function UpdatePreview(value0) {
        this.value0 = value0;
    };
    UpdatePreview.create = function (value0) {
        return new UpdatePreview(value0);
    };
    return UpdatePreview;
})();
var UpdatePreviews = (function () {
    function UpdatePreviews() {

    };
    UpdatePreviews.value = new UpdatePreviews();
    return UpdatePreviews;
})();
var MoveTo = (function () {
    function MoveTo(value0) {
        this.value0 = value0;
    };
    MoveTo.create = function (value0) {
        return new MoveTo(value0);
    };
    return MoveTo;
})();
var UpdateOverwrite = (function () {
    function UpdateOverwrite(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    UpdateOverwrite.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new UpdateOverwrite(value0, value1, value2);
            };
        };
    };
    return UpdateOverwrite;
})();
var CreateConnection = (function () {
    function CreateConnection(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    CreateConnection.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new CreateConnection(value0, value1, value2);
            };
        };
    };
    return CreateConnection;
})();
var SelectInput = (function () {
    function SelectInput(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SelectInput.create = function (value0) {
        return function (value1) {
            return new SelectInput(value0, value1);
        };
    };
    return SelectInput;
})();
var SelectOutput = (function () {
    function SelectOutput(value0) {
        this.value0 = value0;
    };
    SelectOutput.create = function (value0) {
        return new SelectOutput(value0);
    };
    return SelectOutput;
})();
var HandleConnectionConfirmation = (function () {
    function HandleConnectionConfirmation(value0) {
        this.value0 = value0;
    };
    HandleConnectionConfirmation.create = function (value0) {
        return new HandleConnectionConfirmation(value0);
    };
    return HandleConnectionConfirmation;
})();
var GotoId = (function () {
    function GotoId(value0) {
        this.value0 = value0;
    };
    GotoId.create = function (value0) {
        return new GotoId(value0);
    };
    return GotoId;
})();
var StartNodeEditing = (function () {
    function StartNodeEditing(value0) {
        this.value0 = value0;
    };
    StartNodeEditing.create = function (value0) {
        return new StartNodeEditing(value0);
    };
    return StartNodeEditing;
})();
var HandleNodeEdits = (function () {
    function HandleNodeEdits(value0) {
        this.value0 = value0;
    };
    HandleNodeEdits.create = function (value0) {
        return new HandleNodeEdits(value0);
    };
    return HandleNodeEdits;
})();
var Autosave = (function () {
    function Autosave(value0) {
        this.value0 = value0;
    };
    Autosave.create = function (value0) {
        return new Autosave(value0);
    };
    return Autosave;
})();
var EmitState = (function () {
    function EmitState() {

    };
    EmitState.value = new EmitState();
    return EmitState;
})();
var searchNodeInputRef = "search node";
var searchNodeClassName = "node-search__input";
var pendingConnectionModal = {
    id: "confirm-connection",
    title: "Confirm connection",
    content: Data_Function["const"](Halogen_HTML_Core.text("Connecting those nodes would change the type of this function creating a type error.")),
    buttons: [ {
        text: "Continue",
        primary: true,
        value: ProceedConnecting.value
    }, {
        text: "Cancel",
        primary: false,
        value: CancelConnecting.value
    } ],
    onClose: CancelConnecting.value
};
var nodeEditingModal = {
    id: "edit-node",
    title: "[Node name here]",
    content: function (v) {
        return Halogen_HTML_Core.text("[Content goes here]");
    },
    buttons: [ {
        text: "Delete",
        primary: false,
        value: NEDeleteNode.value
    }, {
        text: "Back",
        primary: true,
        value: NECloseModal.value
    } ],
    onClose: NECloseModal.value
};
var component = function (dictMonadAff) {
    return function (dictMonadEffect) {
        return function (dictMonadReader) {
            return function (dictNavigate) {
                var sidebarIcon = function (text) {
                    return function (extraClasses) {
                        return function (activeTab) {
                            return function (current) {
                                var isActive = Data_Eq.eq(Lunarbox_Data_Tab.eqTab)(current)(activeTab);
                                return Lunarbox_Component_Tooltip.tooltip(text)(Lunarbox_Component_Tooltip.Right.value)(Halogen_HTML_Elements.div)([ Halogen_HTML_Properties.classes(Data_Functor.map(Data_Functor.functorArray)(Halogen_HTML_Core.ClassName)(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ "editor__activity" ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Functor.voidLeft(Data_Functor.functorArray)(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(isActive))("editor__activity--active"))(extraClasses)))), Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(new ChangeTab(current)))) ])([ Lunarbox_Component_Icon.icon(Lunarbox_Data_Tab.tabIcon(current)) ]);
                            };
                        };
                    };
                };
                var tabs = function (variant) {
                    return function (currentTab) {
                        var problemClasses = (function () {
                            if (variant instanceof Errors) {
                                return [ "editor__activity--error" ];
                            };
                            if (variant instanceof Warnings) {
                                return [ "editor__activity--warning" ];
                            };
                            if (variant instanceof NoProblems) {
                                return [  ];
                            };
                            throw new Error("Failed pattern match at Lunarbox.Component.Editor (line 576, column 22 - line 579, column 23): " + [ variant.constructor.name ]);
                        })();
                        var classes = function (v) {
                            if (v instanceof Lunarbox_Data_Tab.Problems) {
                                return problemClasses;
                            };
                            return [  ];
                        };
                        var icon = function (tab) {
                            return sidebarIcon(Data_Show.show(Lunarbox_Data_Tab.showTab)(tab))(classes(tab))(currentTab)(tab);
                        };
                        return [ icon(Lunarbox_Data_Tab.Settings.value), icon(Lunarbox_Data_Tab.Add.value), icon(Lunarbox_Data_Tab.Tree.value), icon(Lunarbox_Data_Tab.Problems.value) ];
                    };
                };
                var mkPanel = function (v) {
                    return [ Halogen_HTML_Elements.header([ Lunarbox_Component_Utils.className("panel__header") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("panel__title-container") ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Halogen_HTML_Elements.h1([ Lunarbox_Component_Utils.className("panel__title") ])([ Halogen_HTML_Core.text(v.title) ]) ])(Data_Functor.map(Data_Functor.functorArray)(function (action) {
                        return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("panel__action"), Halogen_HTML_Events.onClick(Data_Function["const"](action.onClick)) ])([ Lunarbox_Component_Icon.icon(action.icon) ]);
                    })(v.actions))), Lunarbox_Component_Utils.maybeElement(v.header)(Control_Category.identity(Control_Category.categoryFn)) ]), Halogen_HTML_Elements.main([ Lunarbox_Component_Utils.className("panel__content") ])(v.content), Lunarbox_Component_Utils.maybeElement(v.footer)(function (inner) {
                        return Halogen_HTML_Elements.footer([ Lunarbox_Component_Utils.className("panel__footer") ])([ inner ]);
                    }) ];
                };
                var logoElement = Halogen_HTML_Elements.img([ Halogen_HTML_Properties.src("https://cdn.discordapp.com/attachments/672889285438865453/708081533151477890/favicon.png"), Halogen_HTML_Properties.alt("Lunarbox logo"), Lunarbox_Component_Utils.className("editor__logo"), Halogen_HTML_Events.onMouseUp(Data_Function["const"](Data_Maybe.Just.create(new Navigate(Lunarbox_Data_Route.Home.value)))) ]);
                var isInternal = function (functions) {
                    return function (functionName) {
                        return Data_Maybe.maybe(true)(Data_Lens_Prism.is(Data_HeytingAlgebra.heytingAlgebraBoolean)(Lunarbox_Data_Editor_DataflowFunction["_NativeFunction"](Data_Lens_Internal_Market.choiceMarket)))(Data_Map_Internal.lookup(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(functionName)(functions));
                    };
                };
                var handleTreeOutput = function (v) {
                    if (v instanceof Lunarbox_Component_Editor_Tree.CreatedFunction) {
                        return Data_Maybe.Just.create(new CreateFunction(v.value0));
                    };
                    if (v instanceof Lunarbox_Component_Editor_Tree.SelectedFunction) {
                        return Data_Maybe.Just.create(new SelectFunction(v.value0));
                    };
                    throw new Error("Failed pattern match at Lunarbox.Component.Editor (line 543, column 22 - line 545, column 62): " + [ v.constructor.name ]);
                };
                var panel = function (v) {
                    if (v.currentTab instanceof Lunarbox_Data_Tab.Settings) {
                        return mkPanel({
                            title: "Project settings",
                            actions: [  ],
                            footer: Data_Maybe.Nothing.value,
                            header: Data_Maybe.Nothing.value,
                            content: [ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("setting") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("setting__label") ])([ Halogen_HTML_Core.text("Name:") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.value(v.name), Halogen_HTML_Properties.placeholder("Project name"), Lunarbox_Component_Utils.className("setting__text-input"), Halogen_HTML_Events.onValueInput(function ($179) {
                                return Data_Maybe.Just.create(SetName.create($179));
                            }) ]) ]), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("setting") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("setting__label") ])([ Halogen_HTML_Core.text("Visibility:") ]), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("setting__switch-input") ])([ Lunarbox_Component_Switch["switch"]({
                                checked: v.isVisible,
                                round: true
                            })(function ($180) {
                                return Data_Maybe.Just.create(SetVisibility.create($180));
                            }) ]) ]), Lunarbox_Component_Utils.whenElem(v.isAdmin)(function (v1) {
                                return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("setting") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("setting__label") ])([ Halogen_HTML_Core.text("Example:") ]), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("setting__switch-input") ])([ Lunarbox_Component_Switch["switch"]({
                                    checked: v.isExample,
                                    round: true
                                })(function ($181) {
                                    return Data_Maybe.Just.create(SetExample.create($181));
                                }) ]) ]);
                            }) ]
                        });
                    };
                    if (v.currentTab instanceof Lunarbox_Data_Tab.Tree) {
                        return mkPanel({
                            title: "Explorer",
                            actions: [ {
                                icon: "note_add",
                                onClick: new Data_Maybe.Just(StartFunctionCreation.value)
                            } ],
                            footer: Data_Maybe.Nothing.value,
                            header: Data_Maybe.Nothing.value,
                            content: [ Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                return "tree";
                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Editor_Tree.component(dictMonadAff.MonadEffect0())(dictMonadReader))({
                                functions: new Data_List_Types.Cons(v.currentFunction, Data_Set.toUnfoldable(Data_List_Types.unfoldableList)(Data_Map.keys(Lunarbox_Data_Editor_Node_NodeDescriptor.onlyEditable(v.currentFunction)(v.project)))),
                                selected: v.currentFunction
                            })(handleTreeOutput) ]
                        });
                    };
                    if (v.currentTab instanceof Lunarbox_Data_Tab.Add) {
                        return mkPanel({
                            title: "Add node",
                            actions: [  ],
                            header: Data_Maybe.Just.create(Data_Function.flip(Halogen_HTML.lazy)(v.nodeSearchTerm)(function (nodeSearchTerm$prime) {
                                return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("node-search") ])([ Halogen_HTML_Elements.input([ Halogen_HTML_Properties.placeholder("Search nodes. Eg: add, greater than..."), Halogen_HTML_Properties.value(nodeSearchTerm$prime), Halogen_HTML_Properties.ref(searchNodeInputRef), Lunarbox_Component_Utils.className(searchNodeClassName), Halogen_HTML_Events.onKeyUp(function ($182) {
                                    return Data_Maybe.Just.create(HandleAddPanelKeyPress.create($182));
                                }), Halogen_HTML_Events.onValueInput(function ($183) {
                                    return Data_Maybe.Just.create(SearchNodes.create($183));
                                }) ]), Lunarbox_Component_Icon.icon("search") ]);
                            })),
                            footer: Data_Maybe.Just.create(Halogen_HTML_Elements.button([ Lunarbox_Component_Utils.className("unselectable node-panel__create-input-button"), Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(CreateNode.create("input")))) ])([ Halogen_HTML_Core.text("Create input node") ])),
                            content: [ Halogen_HTML.lazy2(Lunarbox_Component_Editor_Add.add(dictMonadAff.MonadEffect0()))({
                                project: v.project,
                                currentFunction: v.currentFunction,
                                functionData: v.functionData,
                                typeMap: v.typeMap,
                                inputCountMap: v.inputCountMap,
                                nodeSearchTerm: v.nodeSearchTerm
                            })({
                                edit: function ($184) {
                                    return Data_Maybe.Just.create(SelectFunction.create($184));
                                },
                                addNode: function ($185) {
                                    return Data_Maybe.Just.create(CreateNode.create($185));
                                },
                                changeInputCount: function ($186) {
                                    return (function (v1) {
                                        return function ($187) {
                                            return Data_Maybe.Just.create(v1($187));
                                        };
                                    })(ChangeInputCount.create($186));
                                },
                                "delete": function ($188) {
                                    return Data_Maybe.Just.create(DeleteFunction.create($188));
                                },
                                updatePreview: function ($189) {
                                    return Data_Maybe.Just.create(UpdatePreview.create($189));
                                }
                            }) ]
                        });
                    };
                    if (v.currentTab instanceof Lunarbox_Data_Tab.Problems) {
                        return mkPanel({
                            title: "Problems",
                            actions: [  ],
                            footer: Data_Maybe.Nothing.value,
                            header: Data_Maybe.Nothing.value,
                            content: [ Lunarbox_Component_Editor_Problems.problems({
                                typeErrors: v.typeErrors,
                                lintingErrors: v.lintingErrors,
                                navigateTo: MoveTo.create,
                                isInternal: isInternal(v.project.functions)
                            }) ]
                        });
                    };
                    throw new Error("Failed pattern match at Lunarbox.Component.Editor (line 623, column 7 - line 730, column 10): " + [ v.currentTab.constructor.name ]);
                };
                var handleSceneOutput = function (v) {
                    if (v.value0 instanceof Lunarbox_Foreign_Render.CreateConnection) {
                        return Data_Maybe.Just.create(new CreateConnection(v.value0.value0, v.value0.value1, v.value0.value2));
                    };
                    if (v.value0 instanceof Lunarbox_Foreign_Render.SelectOutput) {
                        return Data_Maybe.Just.create(new SelectOutput(v.value0.value0));
                    };
                    if (v.value0 instanceof Lunarbox_Foreign_Render.SelectInput) {
                        return Data_Maybe.Just.create(new SelectInput(v.value0.value0, v.value0.value1));
                    };
                    if (v.value0 instanceof Lunarbox_Foreign_Render.DeleteConnection) {
                        return Data_Maybe.Just.create(new RemoveConnection(v.value0.value0, v.value0.value1));
                    };
                    if (v.value0 instanceof Lunarbox_Foreign_Render.EditNode) {
                        return Data_Maybe.Just.create(new StartNodeEditing(v.value0.value0));
                    };
                    if (v.value0 instanceof Lunarbox_Foreign_Render.Goto) {
                        return Data_Maybe.Just.create(new GotoId(v.value0.value0));
                    };
                    return Data_Maybe.Nothing.value;
                };
                var scene = Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                    return "scene";
                }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Editor_Scene.component(dictMonadAff.MonadEffect0())(dictMonadReader.MonadAsk0())(dictMonadAff))(Data_Unit.unit)(handleSceneOutput);
                var render = function (v) {
                    var shouldRender$prime = Lunarbox_Component_Editor_Problems.shouldRender(isInternal(v.project.functions));
                    var problemsIconVariant = (function () {
                        if (Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function ($190) {
                            return shouldRender$prime(Lunarbox_Data_Dataflow_TypeError.getLocation($190));
                        })(v.typeErrors)) {
                            return Errors.value;
                        };
                        if (Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(function ($191) {
                            return shouldRender$prime(Lunarbox_Data_Dataflow_Expression_Lint.getLocation($191));
                        })(v.lintingErrors)) {
                            return Warnings.value;
                        };
                        if (Data_Boolean.otherwise) {
                            return NoProblems.value;
                        };
                        throw new Error("Failed pattern match at Lunarbox.Component.Editor (line 774, column 5 - line 777, column 31): " + [  ]);
                    })();
                    var handleNodeSave = function (v1) {
                        if (v1 instanceof Lunarbox_Component_Modal.ClosedWith) {
                            return Data_Maybe.Just.create(new HandleNodeEdits(v1.value0));
                        };
                        if (v1 instanceof Lunarbox_Component_Modal.BubbledAction) {
                            return new Data_Maybe.Just(v1.value0);
                        };
                        throw new Error("Failed pattern match at Lunarbox.Component.Editor (line 783, column 22 - line 785, column 48): " + [ v1.constructor.name ]);
                    };
                    var handleConnectionConfirmation = function (v1) {
                        if (v1 instanceof Lunarbox_Component_Modal.ClosedWith) {
                            return Data_Maybe.Just.create(new HandleConnectionConfirmation(v1.value0));
                        };
                        if (v1 instanceof Lunarbox_Component_Modal.BubbledAction) {
                            return new Data_Maybe.Just(v1.value0);
                        };
                        throw new Error("Failed pattern match at Lunarbox.Component.Editor (line 779, column 36 - line 781, column 48): " + [ v1.constructor.name ]);
                    };
                    return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("editor") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("editor__activity-bar") ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(tabs(problemsIconVariant)(v.currentTab))(Control_Applicative.pure(Control_Applicative.applicativeArray)(logoElement))), Halogen_HTML_Elements.div([ Halogen_HTML_Properties.classes(Data_Functor.map(Data_Functor.functorArray)(Halogen_HTML_Core.ClassName)(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ "panel" ])(Data_Functor.voidLeft(Data_Functor.functorArray)(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(v.panelIsOpen))("panel--open")))) ])(panel(v)), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("scene") ])([ scene ]), Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                        return "pendingConnection";
                    }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Modal.component(dictMonadAff.MonadEffect0())(dictMonadAff))(pendingConnectionModal)(handleConnectionConfirmation), Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                        return "editNode";
                    }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Modal.component(dictMonadAff.MonadEffect0())(dictMonadAff))(nodeEditingModal)(handleNodeSave) ]);
                };
                var handleQuery = function (v) {
                    return Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(Data_Functor.map(Data_Functor.functorFn)(Data_Maybe.Just.create)(v.value0))(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM));
                };
                var handleAction = function (v) {
                    if (v instanceof Init) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_HTML.window))(function (window) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_HTML_Window.document(window)))(function (document) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(handleAction(LoadScene.value))(function () {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM["subscribe'"](function (sid) {
                                        return Halogen_Query_EventSource.eventListenerEventSource(dictMonadAff)(Web_UIEvent_KeyboardEvent_EventTypes.keydown)(Web_HTML_HTMLDocument.toEventTarget(document))((function () {
                                            var $192 = Data_Functor.map(Data_Maybe.functorMaybe)(HandleKey.create(sid));
                                            return function ($193) {
                                                return $192(Web_UIEvent_KeyboardEvent.fromEvent($193));
                                            };
                                        })());
                                    }))(function () {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                            return v1.emitInterval;
                                        }))(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(function (interval) {
                                            return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.subscribe(Data_Functor.voidRight(Halogen_Query_EventSource.functorEventSource(((((dictMonadAff.MonadEffect0()).Monad0()).Bind1()).Apply0()).Functor0()))(EmitState.value)(Lunarbox_Component_Utils.intervalEventSource(dictMonadAff)(interval))));
                                        })))(function () {
                                            return Control_Bind.bindFlipped(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                                var $194 = Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM);
                                                return function ($195) {
                                                    return $194(Halogen_Query_HalogenM.fork(handleAction(Autosave.create(Lunarbox_Data_Editor_Save.stateToJson($195)))));
                                                };
                                            })())(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM));
                                        });
                                    });
                                });
                            });
                        });
                    };
                    if (v instanceof HandleKey) {
                        if (Web_UIEvent_KeyboardEvent.ctrlKey(v.value1) && Web_UIEvent_KeyboardEvent.key(v.value1) === "b") {
                            return handleAction(TogglePanel.value);
                        };
                        if (Web_UIEvent_KeyboardEvent.ctrlKey(v.value1) && Web_UIEvent_KeyboardEvent.key(v.value1) === "i") {
                            return handleAction(CreateNode.create("input"));
                        };
                        if (Web_UIEvent_KeyboardEvent.key(v.value1) === "s") {
                            var targetInput = Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Web_HTML_HTMLInputElement.fromEventTarget)(Web_Event_Event.target(Web_UIEvent_KeyboardEvent.toEvent(v.value1)));
                            return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Maybe.isNothing(targetInput))(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Applicative.unless(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.eq(Lunarbox_Data_Tab.eqTab)(v1.currentTab)(Lunarbox_Data_Tab.Add.value) && v1.panelIsOpen)(Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                    var $196 = Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_panelIsOpen"](Data_Profunctor_Strong.strongFn))(true);
                                    var $197 = Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_currentTab"](Data_Profunctor_Strong.strongFn))(Lunarbox_Data_Tab.Add.value);
                                    return function ($198) {
                                        return $196($197($198));
                                    };
                                })()))(function () {
                                    return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                        return "scene";
                                    }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Halogen_Query.tell(Lunarbox_Component_Editor_Scene.HandleResize.create)));
                                })))(function () {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_Event_Event.preventDefault(Web_UIEvent_KeyboardEvent.toEvent(v.value1))))(function () {
                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.getHTMLElementRef(searchNodeInputRef))(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)((function () {
                                            var $199 = Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()));
                                            return function ($200) {
                                                return $199(Web_HTML_HTMLElement.focus($200));
                                            };
                                        })()));
                                    });
                                });
                            }));
                        };
                        if (Data_Boolean.otherwise) {
                            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                        };
                    };
                    if (v instanceof HandleAddPanelKeyPress) {
                        if (Web_UIEvent_KeyboardEvent.key(v.value0) === "Enter") {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_State.searchNode))(function (sortedFunctions) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Getter.view(Lunarbox_Data_Editor_State["_currentFunction"](Data_Lens_Internal_Forget.strongForget))))(function (currentFunction) {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                        var $201 = Lunarbox_Data_Class_GraphRep.toGraph(Lunarbox_Data_Editor_Project.graphRepProject);
                                        return function ($202) {
                                            return $201((function (v1) {
                                                return v1.project;
                                            })($202));
                                        };
                                    })()))(function (functionGraph) {
                                        var bestMatch = Data_Array.index(sortedFunctions)(0);
                                        var wouldCycle = function (v1) {
                                            return Data_Maybe.maybe(false)(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean))(Control_Apply.apply(Data_Maybe.applyMaybe)(Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Lunarbox_Data_Graph.wouldCreateLongCycle(Lunarbox_Data_Editor_FunctionName.ordFunctionName))(bestMatch))(new Data_Maybe.Just(currentFunction)))(new Data_Maybe.Just(functionGraph)));
                                        };
                                        return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.eq(Data_Maybe.eqMaybe(Lunarbox_Data_Editor_FunctionName.eqFunctionName))(new Data_Maybe.Just(currentFunction))(bestMatch) || wouldCycle(Data_Unit.unit))(Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(bestMatch)(function ($203) {
                                            return handleAction(CreateNode.create($203));
                                        }));
                                    });
                                });
                            });
                        };
                        if (Web_UIEvent_KeyboardEvent.ctrlKey(v.value0) && (Web_UIEvent_KeyboardEvent.shiftKey(v.value0) && Web_UIEvent_KeyboardEvent.key(v.value0) === " ")) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.getHTMLElementRef(searchNodeInputRef))(function (inputElement) {
                                return Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(Control_Bind.bind(Data_Maybe.bindMaybe)(inputElement)(Web_HTML_HTMLInputElement.fromHTMLElement))(function (elem) {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (state) {
                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_HTML_HTMLInputElement.value(elem)))(function (inputValue) {
                                            var exists = Lunarbox_Data_Editor_State.functionExists(inputValue)(state);
                                            var $102 = inputValue !== "" && !exists;
                                            if ($102) {
                                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Data_Editor_State.initializeFunction(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(inputValue)(state))(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM));
                                            };
                                            if (exists) {
                                                return handleAction(new SelectFunction(inputValue));
                                            };
                                            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                        });
                                    });
                                });
                            });
                        };
                        if (Web_UIEvent_KeyboardEvent.ctrlKey(v.value0) && Web_UIEvent_KeyboardEvent.key(v.value0) === " ") {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_State.searchNode))(function (sortedFunctions) {
                                return Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(Data_Array.index(sortedFunctions)(0))(function ($204) {
                                    return handleAction(SelectFunction.create($204));
                                });
                            });
                        };
                        if (Data_Boolean.otherwise) {
                            return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_Event_Event.stopPropagation(Web_UIEvent_KeyboardEvent.toEvent(v.value0)));
                        };
                    };
                    if (v instanceof CreateNode) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Data_Editor_State.createNode(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Halogen_Query_HalogenM.monadStateHalogenM)(v.value0))(function () {
                            return handleAction(Rerender.value);
                        });
                    };
                    if (v instanceof TogglePanel) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.over(Lunarbox_Data_Editor_State["_panelIsOpen"](Data_Profunctor_Strong.strongFn))(Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean))))(function () {
                            return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                return "scene";
                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Halogen_Query.tell(Lunarbox_Component_Editor_Scene.HandleResize.create)));
                        });
                    };
                    if (v instanceof ChangeTab) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Getter.view(Lunarbox_Data_Editor_State["_currentTab"](Data_Lens_Internal_Forget.strongForget))))(function (oldTab) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Getter.view(Lunarbox_Data_Editor_State["_panelIsOpen"](Data_Lens_Internal_Forget.strongForget))))(function (panelWasOpen) {
                                var $106 = Data_Eq.eq(Lunarbox_Data_Tab.eqTab)(oldTab)(v.value0);
                                if ($106) {
                                    return handleAction(TogglePanel.value);
                                };
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                    var $205 = Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_currentTab"](Data_Profunctor_Strong.strongFn))(v.value0);
                                    var $206 = Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_panelIsOpen"](Data_Profunctor_Strong.strongFn))(true);
                                    return function ($207) {
                                        return $205($206($207));
                                    };
                                })()))(function () {
                                    return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                        return "scene";
                                    }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Halogen_Query.tell(Lunarbox_Component_Editor_Scene.HandleResize.create)));
                                });
                            });
                        });
                    };
                    if (v instanceof CreateFunction) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(Lunarbox_Data_Editor_State.initializeFunction(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(v.value0)))(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)))(function () {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(handleAction(new UpdatePreview(v.value0)))(function () {
                                return handleAction(LoadScene.value);
                            });
                        });
                    };
                    if (v instanceof SelectFunction) {
                        return Lunarbox_Data_Editor_State.withCurrentFunction_(Halogen_Query_HalogenM.monadStateHalogenM)(function (currentFunction) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                var $208 = Control_Bind.join(Data_Maybe.bindMaybe);
                                var $209 = Data_Lens_Fold.preview(Lunarbox_Data_Editor_State["_function"](v.value0)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)));
                                return function ($210) {
                                    return $208($209($210));
                                };
                            })()))(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(function (v1) {
                                if (v1 instanceof Lunarbox_Data_Editor_DataflowFunction.VisualFunction) {
                                    return Control_Applicative.unless(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.eq(Lunarbox_Data_Editor_FunctionName.eqFunctionName)(v.value0)(currentFunction))(Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_State.setCurrentFunction(v.value0)))(function () {
                                        return handleAction(LoadScene.value);
                                    }));
                                };
                                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                            }));
                        });
                    };
                    if (v instanceof StartFunctionCreation) {
                        return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                            return "tree";
                        }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Halogen_Query.tell(Lunarbox_Component_Editor_Tree.StartCreation.create)));
                    };
                    if (v instanceof RemoveConnection) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_State.removeConnection(new Data_Tuple.Tuple(v.value0, v.value1))))(function () {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.updateAll(Halogen_Query_HalogenM.monadStateHalogenM)(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))))(function () {
                                return handleAction(Rerender.value);
                            });
                        });
                    };
                    if (v instanceof ChangeInputCount) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_atInputCount"](v.value0)(Data_Lens_Internal_Wander.wanderFunction))(new Data_Maybe.Just(v.value1))))(function () {
                            return handleAction(new UpdatePreview(v.value0));
                        });
                    };
                    if (v instanceof SetName) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_name"](Data_Profunctor_Strong.strongFn))(v.value0));
                    };
                    if (v instanceof SetVisibility) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_isVisible"](Data_Profunctor_Strong.strongFn))(v.value0));
                    };
                    if (v instanceof SetExample) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Getter.view(Lunarbox_Data_Editor_State["_isAdmin"](Data_Lens_Internal_Forget.strongForget))))(function (isAdmin) {
                            return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(isAdmin)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_isExample"](Data_Profunctor_Strong.strongFn))(v.value0)));
                        });
                    };
                    if (v instanceof SearchNodes) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(Lunarbox_Data_Editor_State["_nodeSearchTerm"](Data_Profunctor_Strong.strongFn))(v.value0));
                    };
                    if (v instanceof DeleteFunction) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_State.deleteFunction(v.value0));
                    };
                    if (v instanceof Autosave) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            return v1.autosaveInterval;
                        }))(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(function (interval) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Aff_Class.liftAff(Halogen_Query_HalogenM.monadAffHalogenM(dictMonadAff))(Effect_Aff.delay(interval)))(function () {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Getter.view(Lunarbox_Data_Editor_State["_name"](Data_Lens_Internal_Forget.strongForget))))(function (name) {
                                    var $121 = Data_String_CodePoints.length(name) >= 2;
                                    if ($121) {
                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_Save.stateToJson))(function (newState) {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Applicative.unless(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.eq(Data_Argonaut_Core.eqJson)(newState)(v.value0))(Halogen_Query_HalogenM.raise(new Save(newState))))(function () {
                                                return handleAction(new Autosave(newState));
                                            });
                                        });
                                    };
                                    return handleAction(new Autosave(v.value0));
                                });
                            });
                        }));
                    };
                    if (v instanceof Navigate) {
                        return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(v.value0);
                    };
                    if (v instanceof Rerender) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(handleAction(UpdatePreviews.value))(function () {
                            return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                return "scene";
                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Halogen_Query.tell(Lunarbox_Component_Editor_Scene.Rerender.create)));
                        });
                    };
                    if (v instanceof LoadScene) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Data_Editor_State.updateAll(Halogen_Query_HalogenM.monadStateHalogenM)(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0())))(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)((function () {
                            var $211 = Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM);
                            var $212 = Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                return "scene";
                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit);
                            return function ($213) {
                                return $211($212(Halogen_Query.tell(Lunarbox_Component_Editor_Scene.LoadScene.create($213))));
                            };
                        })()));
                    };
                    if (v instanceof CreateConnection) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor.map(Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.createConnection(v.value0)(v.value1)(v.value2))(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM)))(function (state) {
                            var compilationResult = Lunarbox_Data_Editor_State.tryCompiling(state);
                            if (compilationResult.typeErrors.length === 0) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_State.evaluate(Record.merge()()(compilationResult)(state))))(function () {
                                    return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.updateAll(Halogen_Query_HalogenM.monadStateHalogenM)(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0())));
                                });
                            };
                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                var $125 = {};
                                for (var $126 in v1) {
                                    if ({}.hasOwnProperty.call(v1, $126)) {
                                        $125[$126] = v1[$126];
                                    };
                                };
                                $125.pendingConnection = new Data_Maybe.Just({
                                    from: v.value0,
                                    toId: v.value1,
                                    toIndex: v.value2,
                                    compilationResult: compilationResult
                                });
                                return $125;
                            }))(function () {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(handleAction(new HandleConnectionConfirmation(ProceedConnecting.value)))(function () {
                                    return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                        return "pendingConnection";
                                    }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Halogen_Query.tell(Lunarbox_Component_Modal.Open.create)));
                                });
                            });
                        });
                    };
                    if (v instanceof SelectInput) {
                        return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.withCurrentGeometries(Halogen_Query_HalogenM.monadStateHalogenM)(function (cache) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (state) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Lunarbox_Foreign_Render.setUnconnectableOutputs(cache)(Lunarbox_Data_Set.toNative(Lunarbox_Data_Editor_State.generateUnconnectableOutputs(new Data_Tuple.Tuple(v.value0, v.value1))(state)))))(function () {
                                    return handleAction(Rerender.value);
                                });
                            });
                        }));
                    };
                    if (v instanceof SelectOutput) {
                        return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.withCurrentGeometries(Halogen_Query_HalogenM.monadStateHalogenM)(function (cache) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (state) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Lunarbox_Foreign_Render.setUnconnectableInputs(cache)(Lunarbox_Data_Set.toNative(Lunarbox_Data_Editor_State.generateUnconnectableInputs(v.value0)(state)))))(function () {
                                    return handleAction(Rerender.value);
                                });
                            });
                        }));
                    };
                    if (v instanceof HandleConnectionConfirmation && v.value0 instanceof CancelConnecting) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            var $134 = {};
                            for (var $135 in v1) {
                                if ({}.hasOwnProperty.call(v1, $135)) {
                                    $134[$135] = v1[$135];
                                };
                            };
                            $134.pendingConnection = Data_Maybe.Nothing.value;
                            return $134;
                        });
                    };
                    if (v instanceof HandleConnectionConfirmation) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                            return v1.pendingConnection;
                        }))(function (p) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                return v1.pendingConnection;
                            }))(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(function (v1) {
                                if (v.value0 instanceof ProceedConnecting) {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (state) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_State.createConnection(v1.from)(v1.toId)(v1.toIndex)(Record.merge()()(v1.compilationResult)((function () {
                                            var $140 = {};
                                            for (var $141 in state) {
                                                if ({}.hasOwnProperty.call(state, $141)) {
                                                    $140[$141] = state[$141];
                                                };
                                            };
                                            $140.pendingConnection = Data_Maybe.Nothing.value;
                                            return $140;
                                        })()))))(function () {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.updateAll(Halogen_Query_HalogenM.monadStateHalogenM)(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))))(function () {
                                                return handleAction(Rerender.value);
                                            });
                                        });
                                    });
                                };
                                if (v.value0 instanceof AutofixConnection) {
                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                        var $143 = {};
                                        for (var $144 in v2) {
                                            if ({}.hasOwnProperty.call(v2, $144)) {
                                                $143[$144] = v2[$144];
                                            };
                                        };
                                        $143.pendingConnection = Data_Maybe.Nothing.value;
                                        return $143;
                                    });
                                };
                                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                            }));
                        });
                    };
                    if (v instanceof DeleteNode) {
                        return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.withCurrentGeometries(Halogen_Query_HalogenM.monadStateHalogenM)(function (cache) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Getter.view(Lunarbox_Data_Editor_State["_currentFunction"](Data_Lens_Internal_Forget.strongForget))))(function (current) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_State.deleteNode(current)(v.value0)))(function () {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Lunarbox_Foreign_Render.deleteNode(cache)(v.value0)))(function () {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.updateAll(Halogen_Query_HalogenM.monadStateHalogenM)(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))))(function () {
                                            return handleAction(Rerender.value);
                                        });
                                    });
                                });
                            });
                        }));
                    };
                    if (v instanceof UpdatePreview) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (state) {
                            return Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(new Lunarbox_Data_Editor_Location.AtFunction(v.value0))(state.typeMap))(function (ty) {
                                var inputs = Data_Maybe["fromMaybe'"](function (v1) {
                                    return Lunarbox_Data_Editor_State.getMaxInputs(v.value0)(state);
                                })(Control_Bind.join(Data_Maybe.bindMaybe)(Data_Lens_Fold.preview(Lunarbox_Data_Editor_State["_atInputCount"](v.value0)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))(state)));
                                return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                    return "nodePreview";
                                }))(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Data_Symbol.SProxy.value)(v.value0)(Halogen_Query.tell(Lunarbox_Component_Editor_NodePreview.Rerender.create(Lunarbox_Data_Editor_State.getFunctionColorMap(inputs)(ty)))));
                            });
                        });
                    };
                    if (v instanceof UpdatePreviews) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Getter.view(Lunarbox_Data_Editor_State["_functions"](Data_Lens_Internal_Forget.strongForget))))(function (functions) {
                            return Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Set.foldableSet)(Data_Map.keys(functions))(function ($214) {
                                return handleAction(UpdatePreview.create($214));
                            });
                        });
                    };
                    if (v instanceof MoveTo) {
                        var steps = Lunarbox_Data_Editor_State.moveTo(v.value0);
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableArray)(steps)(function (v1) {
                            if (v1 instanceof Lunarbox_Data_Editor_State.MoveToFunction) {
                                return handleAction(new SelectFunction(v1.value0));
                            };
                            if (v1 instanceof Lunarbox_Data_Editor_State.CenterNode) {
                                return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.withCurrentGeometries(Halogen_Query_HalogenM.monadStateHalogenM)(function (cache) {
                                    return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Lunarbox_Foreign_Render.centerNode(cache)(v1.value0));
                                }));
                            };
                            if (v1 instanceof Lunarbox_Data_Editor_State.CenterOutput) {
                                return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.withCurrentGeometries(Halogen_Query_HalogenM.monadStateHalogenM)(function (cache) {
                                    return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Lunarbox_Foreign_Render.centerOutput(cache));
                                }));
                            };
                            throw new Error("Failed pattern match at Lunarbox.Component.Editor (line 450, column 18 - line 453, column 95): " + [ v1.constructor.name ]);
                        }))(function () {
                            return Control_Applicative.unless(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Array["null"](steps))(handleAction(Rerender.value));
                        });
                    };
                    if (v instanceof StartNodeEditing) {
                        return Lunarbox_Data_Editor_State.withCurrentFunction_(Halogen_Query_HalogenM.monadStateHalogenM)(function (currentFunction) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (state) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Fold.preview(Lunarbox_Data_Editor_State["_atNode"](currentFunction)(v.value0)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))))(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(function (v1) {
                                    if (v1 instanceof Lunarbox_Data_Editor_Node.ComplexNode) {
                                        var type$prime = Lunarbox_Data_Editor_State.getNodeType(v.value0)(v1["value0"]["function"])(state);
                                        var mkQuery = (function () {
                                            var $215 = Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM);
                                            var $216 = Halogen_Query_HalogenM.query()(new Data_Symbol.IsSymbol(function () {
                                                return "editNode";
                                            }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit);
                                            return function ($217) {
                                                return $215($216($217));
                                            };
                                        })();
                                        var functionData = Data_Lens_Fold.preview((function () {
                                            var $218 = Lunarbox_Data_Editor_State["_atFunctionData"](v1["value0"]["function"])(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst));
                                            var $219 = Data_Lens_Prism_Maybe["_Just"](Data_Lens_Internal_Forget.choiceForget(Data_Maybe_First.monoidFirst));
                                            var $220 = Data_Lens_Iso_Newtype["_Newtype"](Lunarbox_Data_Editor_FunctionData.newtypeFunctionData)(Lunarbox_Data_Editor_FunctionData.newtypeFunctionData)(Data_Lens_Internal_Forget.profunctorForget);
                                            return function ($221) {
                                                return $218($219($220($221)));
                                            };
                                        })())(state);
                                        var inputs = (function () {
                                            var mkInput = function (type$prime$prime) {
                                                return function (docs) {
                                                    return {
                                                        "type'": type$prime$prime,
                                                        name: docs.name,
                                                        description: docs.description
                                                    };
                                                };
                                            };
                                            var inputTypes = Data_Functor.map(Data_Maybe.functorMaybe)(Data_Functor.map(Data_Functor.functorFn)(Data_Array.fromFoldable(Data_List_Types.foldableList))(Lunarbox_Data_Dataflow_Type.inputs))(type$prime);
                                            var inputDocs = Data_Functor.map(Data_Maybe.functorMaybe)(function (v2) {
                                                return v2.inputs;
                                            })(functionData);
                                            var inputStuff = Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Array.zip)(inputTypes))(inputDocs);
                                            return Data_Maybe.fromMaybe([  ])(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.uncurry(mkInput)))(inputStuff));
                                        })();
                                        var description = Data_Functor.map(Data_Maybe.functorMaybe)(function (v2) {
                                            return v2.output.description;
                                        })(functionData);
                                        var modal = {
                                            title: Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v1["value0"]["function"]),
                                            content: function (bubble) {
                                                return Lunarbox_Data_Editor_EditNode.component({
                                                    description: description,
                                                    "type'": type$prime,
                                                    inputs: inputs,
                                                    id: v.value0,
                                                    "function": v1["value0"]["function"],
                                                    setValue: (function () {
                                                        var $222 = Data_Functor.map(Data_Maybe.functorMaybe)((function () {
                                                            var $225 = UpdateOverwrite.create(v.value0)(currentFunction);
                                                            return function ($226) {
                                                                return bubble($225($226));
                                                            };
                                                        })());
                                                        var $223 = Lunarbox_Component_Editor_NodeUi.uiToRuntime(v1["value0"]["function"]);
                                                        return function ($224) {
                                                            return $222($223($224));
                                                        };
                                                    })(),
                                                    value: (function () {
                                                        var v3 = Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(Lunarbox_Data_Editor_Location.InsideFunction.create(currentFunction)(new Lunarbox_Data_Editor_Node_PinLocation.NodeLocation(v.value0)))(Data_Newtype.unwrap(Lunarbox_Data_Dataflow_Runtime_ValueMap.newtypeValueMap)(state.runtimeOverwrites));
                                                        if (v3 instanceof Data_Maybe.Just && v3.value0 instanceof Lunarbox_Data_Dataflow_Runtime_TermEnvironment.Term) {
                                                            return v3.value0.value0;
                                                        };
                                                        return Lunarbox_Data_Dataflow_Runtime.Null.value;
                                                    })()
                                                });
                                            },
                                            buttons: nodeEditingModal.buttons,
                                            id: nodeEditingModal.id,
                                            onClose: nodeEditingModal.onClose
                                        };
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                            var $161 = {};
                                            for (var $162 in v2) {
                                                if ({}.hasOwnProperty.call(v2, $162)) {
                                                    $161[$162] = v2[$162];
                                                };
                                            };
                                            $161.currentlyEditedNode = new Data_Maybe.Just(v.value0);
                                            return $161;
                                        }))(function () {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(mkQuery(Halogen_Query.tell(Lunarbox_Component_Modal.UpdateInput.create(modal))))(function () {
                                                return mkQuery(Halogen_Query.tell(Lunarbox_Component_Modal.Open.create));
                                            });
                                        });
                                    };
                                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                }));
                            });
                        });
                    };
                    if (v instanceof HandleNodeEdits) {
                        return Lunarbox_Data_Editor_State.withCurrentNode_(Halogen_Query_HalogenM.monadStateHalogenM)(function (id) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)((function () {
                                if (v.value0 instanceof NEDeleteNode) {
                                    return handleAction(new DeleteNode(id));
                                };
                                if (v.value0 instanceof NECloseModal) {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Lunarbox_Data_Editor_State.evaluate))(function () {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Lunarbox_Data_Editor_State.updateAll(Halogen_Query_HalogenM.monadStateHalogenM)(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))))(function () {
                                            return handleAction(Rerender.value);
                                        });
                                    });
                                };
                                throw new Error("Failed pattern match at Lunarbox.Component.Editor (line 515, column 9 - line 521, column 34): " + [ v.value0.constructor.name ]);
                            })())(function () {
                                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                    var $168 = {};
                                    for (var $169 in v1) {
                                        if ({}.hasOwnProperty.call(v1, $169)) {
                                            $168[$169] = v1[$169];
                                        };
                                    };
                                    $168.currentlyEditedNode = Data_Maybe.Nothing.value;
                                    return $168;
                                });
                            });
                        });
                    };
                    if (v instanceof GotoId) {
                        return Lunarbox_Data_Editor_State.withCurrentFunction_(Halogen_Query_HalogenM.monadStateHalogenM)(function (currentFunction) {
                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Fold.preview(Lunarbox_Data_Editor_State["_atNode"](currentFunction)(v.value0)(Data_Lens_Internal_Forget.wanderForget(Data_Maybe_First.monoidFirst)))))(Data_Foldable.traverse_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(function (v1) {
                                if (v1 instanceof Lunarbox_Data_Editor_Node.ComplexNode) {
                                    return handleAction(new SelectFunction(v1["value0"]["function"]));
                                };
                                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                            }));
                        });
                    };
                    if (v instanceof UpdateOverwrite) {
                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set((function () {
                            var $227 = Lunarbox_Data_Editor_State["_runtimeOverwrites"](Data_Profunctor_Strong.strongFn);
                            var $228 = Data_Lens_Iso_Newtype["_Newtype"](Lunarbox_Data_Dataflow_Runtime_ValueMap.newtypeValueMap)(Lunarbox_Data_Dataflow_Runtime_ValueMap.newtypeValueMap)(Data_Profunctor.profunctorFn);
                            var $229 = Data_Lens_At.at(Data_Lens_At.atMap(Lunarbox_Data_Editor_Location.ordLocation))(Lunarbox_Data_Editor_Location.InsideFunction.create(v.value1)(new Lunarbox_Data_Editor_Node_PinLocation.NodeLocation(v.value0)))(Data_Profunctor_Strong.strongFn);
                            return function ($230) {
                                return $227($228($229($230)));
                            };
                        })())(Data_Maybe.Just.create(new Lunarbox_Data_Dataflow_Runtime_TermEnvironment.Term(v.value2))));
                    };
                    if (v instanceof EmitState) {
                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (state) {
                            return Halogen_Query_HalogenM.raise(new StateEmit(state));
                        });
                    };
                    throw new Error("Failed pattern match at Lunarbox.Component.Editor (line 228, column 18 - line 540, column 30): " + [ v.constructor.name ]);
                };
                return Halogen_Component.mkComponent({
                    initialState: Control_Category.identity(Control_Category.categoryFn),
                    render: render,
                    "eval": Halogen_Component.mkEval({
                        handleAction: handleAction,
                        handleQuery: handleQuery,
                        receive: Halogen_Component.defaultEval.receive,
                        initialize: new Data_Maybe.Just(Init.value),
                        finalize: Halogen_Component.defaultEval.finalize
                    })
                });
            };
        };
    };
};
module.exports = {
    component: component,
    Init: Init,
    HandleKey: HandleKey,
    ChangeTab: ChangeTab,
    CreateFunction: CreateFunction,
    SelectFunction: SelectFunction,
    CreateNode: CreateNode,
    StartFunctionCreation: StartFunctionCreation,
    RemoveConnection: RemoveConnection,
    TogglePanel: TogglePanel,
    ChangeInputCount: ChangeInputCount,
    SetName: SetName,
    SetExample: SetExample,
    SearchNodes: SearchNodes,
    SetVisibility: SetVisibility,
    HandleAddPanelKeyPress: HandleAddPanelKeyPress,
    DeleteFunction: DeleteFunction,
    Navigate: Navigate,
    LoadScene: LoadScene,
    Rerender: Rerender,
    DeleteNode: DeleteNode,
    UpdatePreview: UpdatePreview,
    UpdatePreviews: UpdatePreviews,
    MoveTo: MoveTo,
    UpdateOverwrite: UpdateOverwrite,
    CreateConnection: CreateConnection,
    SelectInput: SelectInput,
    SelectOutput: SelectOutput,
    HandleConnectionConfirmation: HandleConnectionConfirmation,
    GotoId: GotoId,
    StartNodeEditing: StartNodeEditing,
    HandleNodeEdits: HandleNodeEdits,
    Autosave: Autosave,
    EmitState: EmitState,
    Save: Save,
    StateEmit: StateEmit,
    GetState: GetState,
    AutofixConnection: AutofixConnection,
    CancelConnecting: CancelConnecting,
    ProceedConnecting: ProceedConnecting,
    NEDeleteNode: NEDeleteNode,
    NECloseModal: NECloseModal
};
